<template>
    <div class="ecc-references" ref="eccReferences">
        <div class="container ecc-references__container">
            <div class="row">
                <div class="col-12">
                    <h4>References</h4>

                    <ol v-if="references.length" class="ecc-references__list">
                        <li v-for="item in references" :id="item.id" :key="item.id" :ref="item.id" class="ecc-references__list-item" :class="{ active: activeId === item.id }">
                            <button class="ecc-references__list-item-button" aria-label="Return to text." @click="returnToText">
                                <img src="/assets/icons/up-arrow.svg" aria-hidden="true"/>
                            </button>

                            <div>
                                <span class="ecc-references__list-item-number">{{ item.refnum }}.</span>
                                <div v-html="item.content" class="ecc-references__list-item-content"></div>
                            </div>
                        </li>
                    </ol>

                    <p v-else>Empty data was passed to the 'references' property for this component.</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        references: {
            type: Array,
            required: true
        }
    },
    data: function() {
        return {
            activeId: null,
            sourceAnchor: null
        };
    },
    computed: {
        allIds() {
            return this.references.map(contentObject => contentObject.id);
        }
    },
    mounted() {
        let parentCollapseButtons = [];
        let parentCollapse = this.$refs.eccReferences.closest('.nested-accordion__collapse');

        while (parentCollapse) {
            let previousElementSibling = parentCollapse.previousElementSibling;
            if(parentCollapse && previousElementSibling && previousElementSibling.classList && previousElementSibling.classList.contains('nested-accordion__toggle-button')) {
                parentCollapseButtons.push(previousElementSibling);
                parentCollapse = previousElementSibling.closest('.nested-accordion__collapse');
            } else {
                parentCollapse = null;
            }
        }

        document.body.addEventListener('click', e => {
            let forceScroll = false;
            let hashId = e.target.hash ? e.target.hash.substr(1) : false;
            if(hashId) {
                this.sourceAnchor = e.target;
            }

            let activeIdIndex = this.allIds.indexOf(hashId) > -1 ? this.allIds.indexOf(hashId) : -1;
            if(activeIdIndex > -1) {
                this.activeId = this.allIds[activeIdIndex];

                if(parentCollapseButtons.length > 0) {
                    parentCollapseButtons.forEach( collapseButton => {
                        let collapseId = collapseButton.getAttribute('aria-controls');
                        if(collapseButton.getAttribute('aria-expanded') === 'false' && collapseId) {
                            e.preventDefault();
                            this.$root.$emit('bv::toggle::collapse', collapseId);
                            forceScroll = true;
                        }
                    });

                    if(forceScroll) {
                        setTimeout( () => {
                            this.$refs[hashId][0].scrollIntoView();
                        }, 500);
                    }
                }
            }
        });
    },
    methods: {
        returnToText() {
            if(this.sourceAnchor) {
                this.$nextTick(() => {
                    this.sourceAnchor.scrollIntoView();
                    this.sourceAnchor = null;
                });
            }
            this.activeId = null;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/ecc/ecc-references.vue